import React, { useState, useEffect } from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import BackdropScI from "../../../../services/BackdropScI";
import axios from "axios";
import { uri } from "../../../../help/Api";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import { useBody } from "../style";
import { getTotalAmount } from "../../../../utils/utils";
export  function getcolor(text) {
  try {
      const obj = JSON.parse(text);
      for (let key in obj) {
          if (typeof obj[key] === "string" && obj[key].match(/^#[0-9A-Fa-f]{3,6}$/)) {
              return obj[key];
          }
      }
  } catch {
      return "#f5ebdb";
  }
};
const UnderHeader = (props) => {

  const{found,inv,sta,locInv}=props;
  const clasm = useInvMain();
  const clas = useInvAF();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
  const invColors = sta?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  const styfC = { fontWeight: "500",  color:premiApp.billTemplate === 24  || premiApp.billTemplate === 27?"#000": "#9a3f47" };
  const styfCenter = { fontWeight: "bold",maxHeight:"1rem",minHeight:"1rem",  color:premiApp.billTemplate === 24 || premiApp.billTemplate === 27 ?"#000": "#7f0101" };

  const styL = { textAlign:"left", paddingLeft:"0.5rem" };
  const styR = { textAlign:"right", paddingRight:"0.5rem",  };
  const isPurchase=locInv.ProcTypeInvProc === "02" ||locInv.ProcTypeInvProc === "12"||
  locInv.ProcTypeInvProc === "03"?false:true;  

  return (
    <Grid
      item
      container
      className={clas.Bdyroot}
      style={{ fontWeight: "bold" ,fontFamily: "Amiri-Regular",marginLeft: "0cm",marginRight:"0rem",paddingTop:"0.5rem"}}

    >
      <Grid item xs={12}>
        <Grid item container style={{ direction: "rtl" }}>
          <Grid item xs={6} style={{fontFamily: "Amiri-Regular",paddingTop:"0.3rem"}}
          >
            <Grid item container className={clasm.mincntr}>
            <Grid item xs={12}
            container
            style={{
              border: "solid 0.1px",
              backgroundColor:premiApp.billTemplate === 24 || premiApp.billTemplate === 27?secondColor: "#f5ebdb ",
              paddingTop: "0.3rem",
          }}>
             <Grid item xs={6}  style={{textAlign:"right",paddingRight:"0.5rem"}}>
            {isPurchase?txtA.cusNM:"العميل"}
            </Grid>
                
            <Grid item xs={6} style={{textAlign:"left",paddingLeft:"0.5rem"}}>
            {isPurchase?"Supplier":"Customer"}
            </Grid>
           
              </Grid>
              <Grid item xs={2} className={clas.BdyborBtR} style={styR}>
                {/* {"العميل"} */}
                {isPurchase?txtA.cusNM:"العميل"}
              </Grid>
              <Grid item xs={8} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.cust_name}</Paper>
              </Grid>
              <Grid item xs={2} className={clas.BdyborBtL} style={styL}>
                {"Name"}
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
                {"رقم المبنى"}

              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_no_build_cust}</Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
              {"Build No"}
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
              {"اسم الشارع"}
              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr}>
                <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_name_street_cust}</Paper>
                </Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {"Street Name"}
              </Grid>

              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
              {"الحي"}
              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.tax_name_district_cust}</Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {"District"}
              </Grid>

              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
              {"المدينة"}

              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.tax_name_city_cust}</Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {"City"}

              </Grid>

              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
              {"البلد"}

              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.tax_name_country_cust}</Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {"Country"}
              </Grid>
              <Grid item xs={4} className={clas.BdyborBtR} style={styR}>
              {"الرمز البريدي"}

              </Grid>
              <Grid item xs={4} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot?.tax_zip_code_cust}</Paper>
              </Grid>
              <Grid item xs={4} className={clas.BdyborBtL} style={styL}>
                {"Postal Code"}

              </Grid>

              <Grid item xs={4} className={clas.BdyborBtR} style={styR}>
              {"الرقم الاضافي"}

              </Grid>
              <Grid item xs={4} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot?.tax_additional_address_no_cust}</Paper>
              </Grid>
              <Grid item xs={4} className={clas.BdyborBtL} style={styL}>
                {"Additional No"}
              </Grid>

              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
                {txtA.taxNumr}
              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.tax_no_cust}</Paper>
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {txtE.taxNumr}
              </Grid>
              <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
                {"رقم السجل"}
              </Grid>
              <Grid item xs={6} className={clasm.minborB} style={styfC}>
                {/* <Paper className={clasm.minclr}>{sta.tot?.com_register}</Paper> */}
                <Paper className={clasm.minclr} style={styfCenter}>{sta.tot?.tax_vat_registration_no_cust}</Paper>

              </Grid>
              <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
                {"C R No"}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} style={{fontFamily: "Amiri-Regular",paddingTop:"0.3rem"}}
         
         >
           <Grid item container className={clasm.mincntr}>
           <Grid item xs={12} container  style={{
               border: "solid 0.1px",
               backgroundColor: premiApp.billTemplate === 24 || premiApp.billTemplate === 27?secondColor:"#f5ebdb ",
               paddingTop: "0.3rem",
           }}>
            <Grid item xs={6}  style={{textAlign:"right",paddingRight:"0.5rem"}}>
             {/* {txtA.cusNM} */}
             {isPurchase?"العميل":txtA.cusNM}

             </Grid>
               
             <Grid item xs={6}  style={{textAlign:"left",paddingLeft:"0.5rem"}}>
             {/* {"Supplier"} */}
             {isPurchase?"Customer":"Supplier"}

             </Grid>
             
             </Grid>
             <Grid item xs={2} className={clas.BdyborBtR} style={styR}>
               {/* {txtA.cusNM} */}
               {isPurchase?"Customer":"Supplier"}
             </Grid>
             <Grid item xs={8} className={clasm.minborB}>
               <Paper className={clasm.minclr} style={styfCenter}>{found.Disc1_header_ar}</Paper>
             </Grid>
             <Grid item xs={2} className={clas.BdyborBtL} style={styL}>
               {"Name"}
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
               {"رقم المبنى"}

             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_no_build_found}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
             {"Build No"}
             </Grid>
             <Grid item xs={4} className={clas.BdyborBtR} style={styR}>
             {"اسم الشارع"}
             </Grid>
             <Grid item xs={4} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_name_street_found}</Paper>
             </Grid>
             <Grid item xs={4} className={clas.BdyborBtL} style={styL}>
               {"Street Name"}
             </Grid>

             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
             {"الحي"}

             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.tax_name_district_found}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
               {"District"}
             </Grid>

             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
             {"المدينة"}

             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_name_city_found}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
               {"City"}

             </Grid>

             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
             {"البلد"}

             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_name_country_found}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL}  style={styL}>
               {"Country"}
             </Grid>
             <Grid item xs={4} className={clas.BdyborBtR} style={styR}>
             {"الرمز البريدي"}

             </Grid>
             <Grid item xs={4} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_zip_code_found}</Paper>
             </Grid>
             <Grid item xs={4} className={clas.BdyborBtL} style={styL}>
               {"Postal Code"}

             </Grid>

             <Grid item xs={4} className={clas.BdyborBtR} style={styR}>
             {"الرقم الاضافي"}

             </Grid>
             <Grid item xs={4} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_additional_address_no_found}</Paper>
             </Grid>
             <Grid item xs={4} className={clas.BdyborBtL} style={styL}>
               {"Additional No"}
             </Grid>

             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
               {txtA.taxNumr}
             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot.tax_vat_registration_no_found}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
               {txtE.taxNumr}
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtR} style={styR}>
               {"رقم السجل"}
             </Grid>
             <Grid item xs={6} className={clasm.minborB} style={styfC}>
               <Paper className={clasm.minclr}style={styfCenter}>{sta.tot?.foundaion_bsn_no}</Paper>
             </Grid>
             <Grid item xs={3} className={clas.BdyborBtL} style={styL}>
               {"C R No"}
             </Grid>
           </Grid>
         </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default UnderHeader;
